module.exports = __webpack_public_path__ + "static/cashback_locator-827dc927581f1a1d9f73c6225f246f42.png";